<template>
    <div class="vertical-container vertical-container--in-secondary-content">
        <div class="vertical-container__header vertical-container__header--has-shadow">
            <div class="container">
                <div class="section-header">
                    <div class="section-header__title">
                        <h1>Autorizační kódy</h1>
                    </div>

                    <div class="section-header__button">
                        <button @click="create" primaryadd>
                            <span icon>&plus;</span>
                            Přidat nový
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="vertical-container__content">
            <project-token-container/>
        </div>
    </div>
</template>
<script>
import {defaultModalParameters} from 'domovio-core/src/system/modal/modal.params';
import ProjectTokenContainer
    from '@/modules/ProjectModule/modules/ExtensionModule/components/ProjectToken/ProjectTokenContainer';
import CreateProjectTokenDialog
    from '@/modules/ProjectModule/modules/ExtensionModule/components/ProjectToken/CreateProjectTokenDialog';

export default {
    components: {ProjectTokenContainer},
    mounted() {
        this.$store.dispatch('projects/project/extension/projectToken/loadProjectTokens');
    },
    methods:    {
        create() {
            this.$modal.show(CreateProjectTokenDialog, {}, defaultModalParameters());
        }
    }
}
</script>
